export default __webpack_public_path__ + "static/media/Erri De Luca.9988a12b.jpg";